import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import {
    schemaTemplatesMail,
    schemaTemplatesMailSignature,
    schemaTemplatesOffer,
    schemaTemplatesSystemMail,
} from '../tables';

type Arguments = {
    position?: number;
};

export const schemaTemplateResolver_GetAllTemplates = z.array(
    z.discriminatedUnion('type', [
        schemaTemplatesMail,
        schemaTemplatesOffer,
        schemaTemplatesSystemMail,
        schemaTemplatesMailSignature,
    ]),
);

export type SchemaTemplateResolver_GetAllTemplates = z.infer<typeof schemaTemplateResolver_GetAllTemplates>;

export type TemplateResolver_GetAllTemplates = Resolver<Arguments, SchemaTemplateResolver_GetAllTemplates>;
